import LogoBlock from "../LogoBlock";
import {
  Button,
  IconButton,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { NavLink as RouterLink, useLocation, useMatch, useResolvedPath } from "react-router-dom";
import { ProfileBtn, SignInBtn, SignOutBtn, SignUpBtn } from "../Buttons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "./MainHeader.scss";
import { divide } from "mathjs";
// import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
// import ThreeDRotation from "@mui/icons-material/ThreeDRotation";
// import toothIcon from "./assets/toothIcon.png";
import { Menu as MenuIcon } from "@mui/icons-material";

const FAQ_PDF_LINKS = {
  en: "https://files.dentalbot.pro/client-list-en/client-list-en.pdf",
  ru: "https://files.dentalbot.pro/client-list-ru/client-list-ru.pdf",
  uk: "https://files.dentalbot.pro/client-list-ru/client-list-ru.pdf",
};

const MainHeaderDesktop = () => {
  return (
    <Stack direction={{ xs: "column", sm: "row" }} className="MainHeader-Desktop">
      <LogoBlock />
      <HeaderLinksDesktop />
      <HeaderLanguageDesktop />
      <HeaderSignDesktop />
    </Stack>
  );
};

const MainHeaderMobile = () => {
  const { t: _t, i18n } = useTranslation();
  function changeLanguage(lang) {
    i18n.changeLanguage(lang);
  }
  const location = useLocation();
  const isArticles = location.pathname.startsWith("/articles");

  const isVideos = location.pathname.startsWith("/videos");
  let { isAuth, isHeaderTransparent } = useSelector(({ auth, landing }) => ({
    isAuth: auth.isLoggedIn,
    isHeaderTransparent: landing.isHeaderTransparent,
  }));

  const [show, setShow] = useState(false);
  function toogleShow() {
    setShow((prev) => !prev);
  }

  console.log(show);

  return (
    <Box className="MainHeader-Mobile">
      <Box sx={{ py: 1, px: 1 }} display="flex" alignItems="center">
        <LogoBlock />
        <IconButton onClick={toogleShow} variant="outlined" size="large" color="white" sx={{ ml: "auto" }}>
          <MenuIcon fontSize="inherit" />
        </IconButton>
      </Box>
      <div className={`MobileBurgerMenu ${show ? "MainHeader-Mobile-BurgerMenu-Show" : ""}`}>
        <Box
          sx={{ pt: 1, px: 1, width: "100%", height: "100%" }}
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <Stack direction="row" marginBottom="100px" justifyContent="center" alignItems="center" spacing={2}>
            {!isAuth ? (
              <>
                <SignInBtn />
                <SignUpBtn />
              </>
            ) : (
              <>
                <ProfileBtn />
                <SignOutBtn />
              </>
            )}
          </Stack>
          <Stack direction="column" marginBottom="100px" spacing={7}>
            <Button
              variant={isArticles ? "outlined" : "text"}
              size="large"
              color="white"
              component={RouterLink}
              to={"/articles"}
            >
              {_t("ARTICLES")}
            </Button>
            <Button
              variant="text"
              size="large"
              color="white"
              href={FAQ_PDF_LINKS[i18n.resolvedLanguage]}
              target="_blank"
            >
              {_t("QUESTION-ANSWER")}
            </Button>
            <Button
              variant={isVideos ? "outlined" : "text"}
              size="large"
              color="white"
              component={RouterLink}
              to={"/videos"}
            >
              {_t("VIDEO")}
            </Button>
          </Stack>
          <Stack direction={{ xs: "row", sm: "column", md: "row" }} spacing={4}>
            <Button
              variant={i18n.resolvedLanguage === "uk" ? "outlined" : "text"}
              color="white"
              onClick={() => {
                changeLanguage("uk");
              }}
            >
              UA
            </Button>
            <Button
              variant={i18n.resolvedLanguage === "en" ? "outlined" : "text"}
              color="white"
              onClick={() => {
                changeLanguage("en");
              }}
            >
              EN
            </Button>
            <Button
              variant={i18n.resolvedLanguage === "ru" ? "outlined" : "text"}
              color="white"
              onClick={() => {
                changeLanguage("ru");
              }}
            >
              RU
            </Button>
          </Stack>
        </Box>
      </div>
    </Box>
  );
};

const HeaderLinksDesktop = () => {
  const { t: _t, i18n } = useTranslation();

  const location = useLocation();

  const isArticles = location.pathname.startsWith("/articles");

  const isVideos = location.pathname.startsWith("/videos");

  return (
    <Stack direction="row">
      <Button variant={isArticles ? "outlined" : "text"} color="white" component={RouterLink} to={"/articles"}>
        {_t("ARTICLES")}
      </Button>
      <Button variant="text" color="white" href={FAQ_PDF_LINKS[i18n.resolvedLanguage]} target="_blank">
        {_t("QUESTION-ANSWER")}
      </Button>
      <Button variant={isVideos ? "outlined" : "text"} color="white" component={RouterLink} to={"/videos"}>
        {_t("VIDEO")}
      </Button>
    </Stack>
  );
};

const HeaderLanguageDesktop = () => {
  const { t: _t, i18n } = useTranslation();
  function changeLanguage(lang) {
    i18n.changeLanguage(lang);
  }
  return (
    <Stack direction={{ xs: "row", sm: "column", md: "row" }}>
      <Button
        variant={i18n.resolvedLanguage === "uk" ? "outlined" : "text"}
        color="white"
        onClick={() => {
          changeLanguage("uk");
        }}
      >
        UA
      </Button>
      <Button
        variant={i18n.resolvedLanguage === "en" ? "outlined" : "text"}
        color="white"
        onClick={() => {
          changeLanguage("en");
        }}
      >
        EN
      </Button>
      <Button
        variant={i18n.resolvedLanguage === "ru" ? "outlined" : "text"}
        color="white"
        onClick={() => {
          changeLanguage("ru");
        }}
      >
        RU
      </Button>
    </Stack>
  );
};

const HeaderSignDesktop = () => {
  let { isAuth, isHeaderTransparent } = useSelector(({ auth, landing }) => ({
    isAuth: auth.isLoggedIn,
    isHeaderTransparent: landing.isHeaderTransparent,
  }));
  return (
    <Stack direction={{ xs: "row", sm: "column", md: "row" }} spacing={1}>
      {!isAuth ? (
        <>
          <SignInBtn />
          <SignUpBtn />
        </>
      ) : (
        <>
          <ProfileBtn />
          <SignOutBtn />
        </>
      )}
    </Stack>
  );
};

const MainHeader = () => {
  const isSmall = useMediaQuery("(max-width:768px)");
  let { isAuth, isHeaderTransparent } = useSelector(({ auth, landing }) => ({
    isAuth: auth.isLoggedIn,
    isHeaderTransparent: landing.isHeaderTransparent,
  }));

  return (
    <header className={isHeaderTransparent ? "mainHeader withScroll" : "mainHeader"}>
      {isSmall ? <MainHeaderMobile /> : <MainHeaderDesktop />}
    </header>
  );
};

export default MainHeader;
